export enum BaseInquiryScrollSliderEnum {
  left = 'left',
  right = 'right',
  start = 'start',
  end = 'end',
}
